const number = "[0-9]*";

const decimalNumber = "[0-9]*[.]?[0-9]*";

const alphaNumeric = "[0-9a-Z]*";

const getNumberWithMaxLength = (maxLength) => {
    return "[0-9]{" + maxLength + "}";
};

const inputPattern = {
    number,
    decimalNumber,
    alphaNumeric,
    getNumberWithMaxLength,
};

export default inputPattern;
